module.exports = __webpack_public_path__ + "img/20.8958133b.jpg";